module.exports = __webpack_public_path__ + "static/d15-9bacbf5d9d3aa0b11549e0d9249aa126.png";